export default __webpack_public_path__ + "static/media/actionsList.34df0f38.png";